import { render, staticRenderFns } from "./block-educator.vue?vue&type=template&id=c5854526&scoped=true&"
import script from "./block-educator.vue?vue&type=script&lang=js&"
export * from "./block-educator.vue?vue&type=script&lang=js&"
import style0 from "./block-educator.vue?vue&type=style&index=0&id=c5854526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5854526",
  null
  
)

export default component.exports